import React, { useState } from "react";
import { ThemeSwitch } from "../../components/DarkModeToggle";
import LanguageDropdown from "../../components/LanguageSwitcher";

// Example: fetch presigned URL from your backend
async function getPresignedUrl(fileName: string, fileType: string) {
  const res = await fetch(`/api/upload-url?fileName=${fileName}&fileType=${fileType}`);
  const data = await res.json();
  return data.url; // The presigned URL
}

export default function SettingsPage() {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<any>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsUploading(true);
      setIsError(false);
      setError(null);

      // Get presigned URL from your backend
      const presignedUrl = await getPresignedUrl(file.name, file.type);

      // Upload file directly to R2
      const uploadRes = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      });

      if (!uploadRes.ok) throw new Error("Upload failed");

      // Construct the public URL of the uploaded file
      // Adjust depending on your R2 bucket domain
      const publicUrl = presignedUrl.split("?")[0];
      setFileUrl(publicUrl);
    } catch (err) {
      console.error(err);
      setIsError(true);
      setError(err);
    } finally {
      setIsUploading(false);
    }
  };

  return (
   <div className="flex flex-col pt-30 gap-5">
      <ThemeSwitch />


      <LanguageDropdown/>


     <div className="flex flex-col items-center gap-4 py-6">
      <h2 className="font-bold text-lg">Upload File / Image</h2>

      {isError && <p className="text-red-500">Error: {error?.message}</p>}

      {!isUploading && !fileUrl && <p>No file uploaded yet.</p>}

      {fileUrl && (
        <img
          src={fileUrl}
          alt="Uploaded File"
          className="w-64 h-auto rounded shadow-md border"
        />
      )}

      <label className="cursor-pointer bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
        {isUploading ? "Uploading..." : "Upload New"}
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleFileChange}
          disabled={isUploading}
        />
      </label>
    </div>
   </div>
  );
}